import { render, staticRenderFns } from "./mNav.vue?vue&type=template&id=4721ea72&scoped=true&"
import script from "./mNav.vue?vue&type=script&lang=js&"
export * from "./mNav.vue?vue&type=script&lang=js&"
import style0 from "./mNav.vue?vue&type=style&index=0&id=4721ea72&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4721ea72",
  null
  
)

export default component.exports